/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PostCommentFormContainerLocal = {
    readonly oldestFirstNewCommentsToShow: string | null;
    readonly loadAllButtonHasBeenClicked: boolean | null;
    readonly " $refType": "PostCommentFormContainerLocal";
};
export type PostCommentFormContainerLocal$data = PostCommentFormContainerLocal;
export type PostCommentFormContainerLocal$key = {
    readonly " $data"?: PostCommentFormContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"PostCommentFormContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PostCommentFormContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "oldestFirstNewCommentsToShow",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "loadAllButtonHasBeenClicked",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '8d10dc434847d4f463e23a6311990d0d';
export default node;
